import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { ReorderPipelineStagePosition } from '@/gql/graphql';
import { createDraftPipelineMutation } from './createDraftPipelineMutation';
import draftMutationKeys from './keyFactory';
import { applyOptimisticReorderStage } from './optimisticUpdates';

const REORDER_PIPELINE_STAGE_MUTATION = graphql(`
  mutation ReorderPipelineStage(
    $id: ID!
    $position: ReorderPipelineStagePosition!
  ) {
    reorderPipelineStage(id: $id, position: $position) {
      id
      index
    }
  }
`);

type MutationInput = {
  id: string;
  position: ReorderPipelineStagePosition;
};

const useDraftReorderPipelineStage = createDraftPipelineMutation()({
  mutationKey: draftMutationKeys.reorderPipelineStage,
  mutationFn: (input: MutationInput) => {
    return gqlClient.request(REORDER_PIPELINE_STAGE_MUTATION, input);
  },
  applyOptimisticUpdate: (data, variables) =>
    applyOptimisticReorderStage(data, variables),
  squash: {
    entityId: (v) => v.id,
    merge: (_older, newer) => newer,
  },
});

export default useDraftReorderPipelineStage;
